module.exports = __webpack_public_path__ + "static/img/402.62c0f2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/191025/402.jpg
// module id = eWgv
// module chunks = 0